/**
 * Copyright (c) 2019 Vendor Badge, LLC All Rights Reserved.
 *
 * Customer Portal Application
 */

// Core Modules
import React from 'react';
import { observer } from 'mobx-react';
import { Route, Switch, withRouter } from 'react-router-dom';
import { useStores } from 'stores/RootStore';
import PrivateRoute from 'containers/routers/PrivateRoute';
import { MuiThemeProvider } from '@material-ui/core/styles';
import { SnackbarProvider } from 'notistack';
import withRouterStore from 'containers/services/withRouterStore';

// Components
import Portal from 'containers/pages/Portal/Portal';
import Login from 'containers/pages/Login/Login';
import PageLoader from 'components/PageLoader';
import SnackbarNotifier from 'components/Notifications/SnackbarNotifier';

// Inject Styles/Theme
import CssBaseline from '@material-ui/core/CssBaseline';
import { Asdgard, AsdgardDark } from 'assets/themes/Asdgard/Asdgard.jsx';

const App = props => {
  const stores = useStores();
  const { theme } = stores.portalStore;
  stores.appStore.debug('Container::App - Rendered successfully.');
  return (
    <React.Fragment>
      <CssBaseline />
      <MuiThemeProvider theme={theme.themeType === 'dark' ? AsdgardDark : Asdgard}>
        <SnackbarProvider maxSnack={1} preventDuplicate={true} anchorOrigin={{ vertical: 'top', horizontal: 'right' }}>
          <SnackbarNotifier />
          <PageLoader />
          <Switch>
            <Route path='/login' component={withRouterStore(stores.routerStore)(Login)} />
            <PrivateRoute path='/' component={withRouterStore(stores.routerStore)(Portal)} />
          </Switch>
        </SnackbarProvider>
      </MuiThemeProvider>
    </React.Fragment>
  );
};

export default withRouter(observer(App));
